<template>
	<div class="row-no-full">
		<div class="item" style="display: flex;">
			<!-- <div class="search_input" v-if="this.$route.path =='/main/customer_list'">
				<el-input type="text" placeholder="请输入邮箱" ref="inputValue" v-model="form.email">
					</el-input>
			</div>	 -->
			<div class="search_input">
				<el-input clearable type="text" v-if="this.$route.path =='/main/product_list'" placeholder="请输入商品名---模糊搜索" ref="inputValue" v-model="form.product_name">
				</el-input>
			</div>
			<div class="search_input">
				<el-input clearable type="text" v-if="this.$route.path =='/main/product_list'" placeholder="请输入商品版号---精准搜索" ref="inputValue" v-model="form.product_model">
				</el-input>
			</div>
			<div class="search_input">
				<el-select v-if="this.$route.path =='/main/product_list'" v-model="form.product_status" placeholder="请选择商品状态" clearable>
					<el-option v-for="item in productStatusAll" :key="item.value" :label="item.label" :value="item.value"></el-option>
				</el-select>
			</div>
			<div class="search_input">
				<el-select v-if="this.$route.path =='/main/product_list'" v-model="form.product_sale_type" placeholder="请选择商品类型" clearable>
					<el-option v-for="item in all_product_sale_type" :key="item.id" :label="item.product_sale_name" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="search_input">
				<el-select v-if="this.$route.path =='/main/rakuten_home_hot_series_cloth'" v-model="form.series_type" placeholder="请选择系列" clearable>
					<el-option v-for="item in all_rakuten_series_cloth" :key="item.id" :label="item.series_name" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="search_input" >
				<el-input clearable type="text" v-if="this.$route.path !='/main/product_list' && this.$route.path !='/main/order_list' && this.$route.path !='/main/rakuten_home_hot_series_cloth'" placeholder="请输入邮箱--精准查询" ref="inputValue" v-model="form.email">
				</el-input>
			</div>
			<div   v-if="this.$route.path =='/main/order_list'">
				  <el-input
				    placeholder="请输入内容"
				    v-model="form.keywords"
				    class="input-with-select"
				  >
				    <template #prepend>
				      <el-select v-model="form.select" placeholder="请选择" style="width: 120px;">
				        <el-option label="按姓" value="last_name"></el-option>
				        <el-option label="按商品版号" value="product_model"></el-option>
				        <el-option label="按会员email" value="email"></el-option>
						<el-option label="按订单号" value="order_num"></el-option>
				      </el-select>
				    </template>
				  </el-input>
			</div>
			<div>
				<el-button type='primary'  @click='submit'>搜索</el-button>
			</div>
		</div>
		
	</div>
</template>

<script>
	export default {
		name: 'Search',
		props:{
			page: {
				type: String,
				default: ''
			},
		},
		data() {
			return {
				form:{
					select:'',
					keywords:'',
					product_name:'',
					product_model:'',
					product_status:'',
					product_sale_type:"",
					series_type:'',
					email:'',
					order_num:'',
					customer_name:'',
				},
				all_rakuten_series_cloth:[],
				all_product_sale_type: [],
				productStatusAll: [{
				  value: '1',
				  label: '出售中'
				}, {
				  value: '2',
				  label: '已下架'
				}],
			}
		},
		methods: {
			submit() {
				this.$emit('inputValue', this.form)
			},
			getProductSaleType() {
				this.httpPost({
					url: '/admin/product/productSaleTypeList'
				}).then((re) => {
					let data = re.data
					// console.log(data)
					let temp = this.cloneObj(data);
					this.all_product_sale_type = temp;
			
				}).catch((err) => {})
			},
			rakutenSeriesClothList(){
					this.httpPost({
					url: '/admin/rakuten/rakutenSeriesClothList'
				}).then((re) => {
					let data = re.data
					console.log(data)
					let temp = this.cloneObj(data);
					this.all_rakuten_series_cloth = temp;
					this.loading = false;
				
				}).catch((err) => {
					this.loading = false;
				})
			},
		},
		created() {
			// console.log(this.$route.path)
			if(this.$route.path=='/main/product_list') this.getProductSaleType();
			if(this.$route.path=='/main/rakuten_home_hot_series_cloth') this.rakutenSeriesClothList();

		}
	}
</script>

<style>
	.item>div{
		margin-left: 5px;
	}
	
</style>
